export const listTaskListUnits = `
    query ListTaskListUnits($workspaceId: ID!, $isArchived: Boolean, $limit: Int, $nextToken: String) {
        listTaskListUnits(workspaceId: $workspaceId, isArchived: $isArchived, limit: $limit, nextToken: $nextToken) {
            items {
                id
                ownerId
                workspaceId
                name
                description
                avatarPath
                timezone
                logicalDayShift
                isArchived
                taskLists
                taskListsOrder
                version
                createdAt
                updatedAt
                createdBy
                updatedBy
            }
            nextToken
        }
    }
`;

export const listTasksForUnit = `
    query ListTasksForUnit($workspaceId: ID!, $taskListUnitId: ID!, $isArchived: Boolean, $limit: Int, $nextToken: String) {
        listTasksForUnit(workspaceId: $workspaceId, taskListUnitId: $taskListUnitId, isArchived: $isArchived, limit: $limit, nextToken: $nextToken) {
            items {
                id
                taskListUnitId
                taskListId
                name
                description
                scheduleRule
                relatedPage
                config
                images
                isArchived
                version
                createdAt
                updatedAt
                createdBy
                updatedBy
            }
            nextToken
        }
    }
`;

export const listTasksReportsForUnit = `
    query ListTasksReportsForUnit($workspaceId: ID!, $taskListUnitId: ID!, $startDate: DateTime, $endDate: DateTime, $isArchived: Boolean, $limit: Int, $nextToken: String) {
        listTasksReportsForUnit(workspaceId: $workspaceId, taskListUnitId: $taskListUnitId, startDate: $startDate, endDate: $endDate, isArchived: $isArchived, limit: $limit, nextToken: $nextToken) {
            items {
                id
                taskId
                taskListUnitId
                completedAt
                status
                comment
                images
                commentImages
                completedBy
                logicalDayStart
                version
                createdAt
                updatedAt
                createdBy
                updatedBy
            }
            nextToken
        }
    }
`;

export const hasReports = `
    query HasReports($taskId: ID!) {
        hasReports(taskId: $taskId)
    }
`;